<ng-container *transloco="let t;">
  <app-detail-view [loading]="loading" [messages]="messages" (closed)="onClose()">

    <div title>
      <h1>
        <span *ngIf="newMode()">{{ t('texttemplates.create_texttemplate') }}</span>
        <span *ngIf="editMode()">{{ t('common.labels.texttemplate') }} <strong>{{ texttemplate.identifier }}</strong></span>
      </h1>
    </div>

    <div details>
      <p-tabView (onChange)="onTabChange($event)" [(activeIndex)]="tabIndex">

          <p-tabPanel header="{{ t('common.labels.basedata') }}" leftIcon="pi pi-sliders-h" [disabled]="isDisabled('basedata')">
            <app-texttemplate-basedata *ngIf="editMode()" [texttemplate]="texttemplate" (setEdit)="setEdit($event)"></app-texttemplate-basedata>
          </p-tabPanel>

          <p-tabPanel header="{{ t('common.labels.contents') }}" leftIcon="pi pi-align-left" [disabled]="isDisabled('contents') || texttemplate === null">
            <app-content-editor *ngIf="editMode()" [owner]="texttemplate" [languages]="languages" [mode]="'texttemplates'" [template]="texttemplate?.identifier" (setEdit)="setEdit($event)"></app-content-editor>
          </p-tabPanel>

          <p-tabPanel *ngIf="texttemplate?.type === 'mail'" header="{{ t('common.labels.files') }}" leftIcon="pi pi-file" [disabled]="isDisabled('contents') || texttemplate === null">
            <app-texttemplate-files *ngIf="editMode()" [texttemplate]="texttemplate" [languages]="languages" (setEdit)="setEdit($event)"></app-texttemplate-files>
          </p-tabPanel>

      </p-tabView>
    </div>

  </app-detail-view>
</ng-container>
